import { render, staticRenderFns } from "./RetireRoleDialog.vue?vue&type=template&id=3dbf1684&scoped=true"
import script from "./RetireRoleDialog.vue?vue&type=script&lang=js"
export * from "./RetireRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbf1684",
  null
  
)

export default component.exports